import type { ReactiveControllerHost } from 'lit';
import { CustomError } from '../../../../_ui-core_/base/package/patterns/package/CError';
import App from '../../../../app';
import BaseController, { type EventAction, type IGameController } from '../base-controller';

type MerkurEvent = {
  data?: { balance?: number };
  name: string;
  sender: string;
};

export default class MerkurGameController extends BaseController implements IGameController {
  constructor(host: ReactiveControllerHost) {
    super(host, 'merkur');
  }

  public async getLaunchUrl(forReal: boolean, gameId: string): Promise<string> {
    try {
      const info = await App.instance.casino.getGameLaunchInfo(this.provider, gameId, forReal);

      // temp solution to enable launch with responses returned from provider-integration
      if (info.launchConfig.launchUrl) {
        return info.launchConfig.launchUrl;
      }

      if (!info.launchConfig.serverUrl || !info.launchConfig.operatorId) {
        return Promise.reject(new CustomError('Missing fields in info.launchConfig.', { code: 404 }));
      }

      const searchParams = new URLSearchParams({
        casino: info.launchConfig.operatorId,
        gameKey: gameId,
        lang: MerkurGameController.formatLanguage(info.language),
        gameMode: forReal ? 'money' : 'fun',
        playerId: forReal && info.playForReal ? info.playForReal.accountId : '',
        startToken: forReal && info.playForReal ? info.playForReal.token : '',
      });

      return `${info.launchConfig.serverUrl}/gamestart.html?${searchParams}`;
    } catch (error: any) {
      return Promise.reject(
        new CustomError(`Failed to get game launch info: ${error.message}`, {
          code: error.code || 500,
          type: error.type,
        }),
      );
    }
  }

  public getLaunchUrlIOs(forReal: boolean, gameId: string, gameBaseUrl: string): Promise<string> {
    window.$app.logger.warn('TODO - NATIVE GAME LAUNCH NOT IMPLEMENTED!', gameBaseUrl);
    return this.getLaunchUrl(forReal, gameId); // TODO
  }

  public handleMessageEvent(data: string | MerkurEvent): EventAction | null {
    window.$app.logger.log('message', data);
    if (typeof data === 'string') {
      switch (data) {
        case 'gameRoundStarted':
          return this.markActivity();
        case 'gameRoundEnded':
          return this.markActivityAndSpinSuccess();
        case 'audioEnabled':
          return this.markActivity();
        case 'audioDisabled':
          return this.markActivity();
        case 'notifyCloseContainer':
          return this.closeGame();
      }
    }
    if (typeof data === 'object') {
      switch (data.name) {
        case 'balanceUpdated':
          return this.balanceUpdated(data.data?.balance);
      }
    }
    return null;
  }

  public handleAdditionalEventListeners(_iframeUrl: string, _iframeEl: HTMLIFrameElement) {
    return;
  }

  private static formatLanguage(code: string): string {
    switch (code) {
      case 'en':
        return 'en';
      default:
        return 'de';
    }
  }
}
